import React from 'react';
import LcIconLink from '../LcIconLink';

type Position = 'left' | 'right' | 'fullRight' | 'fullLeft';

interface Props {
    nextSolicitation?: any
    previewSolicitation?: any
    disabledNext?: boolean;
    disabledPrevious?: boolean;
    onClickNext?: Function;
    onClickPrevious?: Function;
    nextColor?: string,
    previousColor?: string,
    nextTooltipPosition?: Position,
    previousTooltipPosition?: Position,
}

const NextAndPreviousButtons: React.FC<Props> = (props) => {
    return (
        <>
            <LcIconLink
                icon='ppi ppi-chevron-left'
                color={props.previousColor}
                disabled={props.disabledPrevious}
                onClick={props.onClickPrevious}
                tooltip={
                    props.previewSolicitation &&
                    <span><strong>{props.previewSolicitation.id}</strong>: {props.previewSolicitation.subject} </span>
                }
                tooltipPosition={"left"}
                tooltipColor={'white'}
            />

            <LcIconLink
                icon='ppi ppi-chevron-right'
                color={props.nextColor}
                disabled={props.disabledNext}
                onClick={props.onClickNext}
                tooltip={
                    props.nextSolicitation &&
                    <span><strong>{props.nextSolicitation.id}</strong>: {props.nextSolicitation.subject} </span>
                }
                tooltipPosition={"moreLeft"}
                tooltipColor={'white'}
            />
        </>
    )
}

export default NextAndPreviousButtons;